import MenuCard from "./MenuCard";

function MenuCardContainer({items, key}) {
    return (
        <div style={styles.container}>
        <MenuCard items={items} key={key} />
        </div>
    );
};

export default MenuCardContainer;

const styles = {
    container: {
        width: '40%',
        margin: '5%',
    }
}